import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {DisplayText, Stack, Link} from '@shopify/polaris';
import {
  ServiceListingCard,
  AppLayout,
} from 'sections/services-marketplace/experts/components';
import {ServiceDimension, Money} from 'sections/types';
import {StringMap} from 'utilities/types';
import {
  Routes,
  fetchServiceDimensions,
} from 'sections/services-marketplace/experts/utilities';
import * as styles from './RelatedServices.scss';
import i18nArgs from '../../locales';

interface RelatedServiceListing {
  handle: string;
  shortLabel: string;
  startingPrice?: Money;
}

interface OwnProps {
  expertHandle: string;
  serviceHandle: string;
  serviceListings: RelatedServiceListing[];
  businessName: string;
  serviceDimensionsMap?: StringMap<ServiceDimension>;
}

type CombinedProps = OwnProps & WithI18nProps;

const LIMIT = 3;

function RelatedServices({
  expertHandle,
  serviceHandle,
  serviceListings,
  businessName,
  serviceDimensionsMap,
  i18n,
}: CombinedProps) {
  if (!serviceListings.length) return null;

  const filteredListings = serviceListings
    .filter(serviceListing => serviceListing.handle !== serviceHandle)
    .filter(serviceListing => serviceListing.startingPrice)
    .slice(0, LIMIT);

  if (!filteredListings.length) return null;

  return (
    <div className={styles.RelatedServicesContainer}>
      <AppLayout>
        <AppLayout.Container subdued slim>
          <AppLayout.Section fill>
            <div className={styles.RelatedServices}>
              <Stack alignment="center">
                <Stack.Item fill>
                  <DisplayText size="large">
                    {i18n.translate('Profile.RelatedServices.title', {
                      expertName: businessName,
                    })}
                  </DisplayText>
                </Stack.Item>
                <Link url={Routes.profilePath(expertHandle)}>
                  {i18n.translate('Profile.RelatedServices.viewAll')}
                </Link>
              </Stack>
              <div className={styles.Grid}>
                {filteredListings.map(service => {
                  const serviceDimensions = fetchServiceDimensions(
                    serviceDimensionsMap,
                    service.handle
                  );
                  const {
                    totalJobsCompleted,
                    averageRating,
                    totalReviews,
                  } = serviceDimensions;

                  return (
                    <div className={styles.GridItem} key={service.handle}>
                      <ServiceListingCard
                        serviceHandle={service.handle}
                        label={service.shortLabel}
                        startingPrice={service.startingPrice}
                        totalJobsCompleted={totalJobsCompleted}
                        averageRating={averageRating}
                        totalReviews={totalReviews}
                        link={service.handle}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </AppLayout.Section>
        </AppLayout.Container>
      </AppLayout>
    </div>
  );
}

export default withI18n(i18nArgs)(RelatedServices);
